// extracted by mini-css-extract-plugin
export default {"article_ads_container":"ads-tab_article_ads_container__792uD"};